import { toast } from "react-toastify";

// Every save of a live listing answers with `pendingChanges` ({ applied, queued,
// proposed?, reverted? }).
// One place turns that into a message, so no edit form has to: changes that wait
// for review are announced, and open banners are told to refresh.

export const PENDING_CHANGES_EVENT = "verati:pending-changes";

const label = (field: string) =>
  field
    .replace(/_/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/\b(ids?|file)\b/gi, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

export const announcePendingChanges = (body: any) => {
  const pending = body?.data?.pendingChanges ?? body?.pendingChanges;
  if (!pending || !Array.isArray(pending.queued)) return;
  // `proposed`: what this save newly sent. An edit form opens on the pending
  // values, so re-saving it re-sends them; those are not news.
  const sent: string[] = Array.isArray(pending.proposed) ? pending.proposed : [];
  if (sent.length > 0) {
    const names = sent.map(label).filter(Boolean);
    toast.info(
      `Sent for review: ${names.join(", ")}. Customers keep seeing the current version until it is approved.`,
      { autoClose: 7000 }
    );
  }
  if (Array.isArray(pending.reverted) && pending.reverted.length > 0) {
    toast.info(`Change taken back: ${pending.reverted.map(label).filter(Boolean).join(", ")}. It no longer waits for review.`, { autoClose: 6000 });
  }
  window.dispatchEvent(new Event(PENDING_CHANGES_EVENT));
};
